import React from 'react'
import { compose } from 'redux'
import PropTypes from 'prop-types'

import { AdvertiserDisclosure } from 'components/advertiser-disclosure'
import WidgetPage from 'components/hocs/widget-page'
import { getMetaQuery } from 'utils/data'
import useActiveLenders from 'components/hooks/useActiveLenders'
import { ADVERTISER_DISCLOSURE_THEMES } from 'common/constants'
import withApolloProvider from 'components/hocs/withApolloProvider'

import FullRateTableApp from './full-table/App'
import ShortenedRateTableApp from './shortened-table'
import { getFilteredLenders } from '../../utils/lenders'

const RateTableApp = (props) => {
  const {
    theme,
    variation,
    metaParams,
    verticals,
    type,
    showRateTableAsFirstPrequalStep,
    initialValues,
  } = props

  const isFullTable = variation !== 'shortened'
  const showDisclosure = ADVERTISER_DISCLOSURE_THEMES.includes(theme)

  const metaQuery = getMetaQuery({ ...metaParams, marketplace: verticals, type }, theme)

  const fetchedLenders = useActiveLenders('personal')
  const availableLenders = getFilteredLenders({
    lenders: fetchedLenders,
    partnerPageUrl: initialValues?.options?.partnerPageUrl,
  })

  const RateTable =
    isFullTable && !showRateTableAsFirstPrequalStep ? (
      <FullRateTableApp
        {...props}
        availableLenders={availableLenders}
        theme={theme}
        metaQuery={metaQuery}
      />
    ) : (
      <ShortenedRateTableApp
        {...props}
        availableLenders={availableLenders}
        theme={theme}
        metaQuery={metaQuery}
        shortened
      />
    )

  return (
    <>
      {showDisclosure && <AdvertiserDisclosure tooltipId="fox-disclosure" theme={theme} />}
      <div>{RateTable}</div>
    </>
  )
}

RateTableApp.propTypes = {
  theme: PropTypes.string,
  variation: PropTypes.string,
  metaParams: PropTypes.object,
  verticals: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  type: PropTypes.string,
  showRateTableAsFirstPrequalStep: PropTypes.bool,
  initialValues: PropTypes.shape({
    options: PropTypes.shape({
      partnerPageUrl: PropTypes.string,
    }),
  }),
}

// Export named class and functions for unit tests
export { RateTableApp }

export default compose(withApolloProvider, WidgetPage)(RateTableApp)
